__turbopack_context__.v({
  "button": "IconButton-module-scss-module__mxJWSG__button",
});
